import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { SmsTemplate_Create, SmsTemplate_Delete, SmsTemplate_Update, SmsTemplate_ReadByTenantId, SmsTemplate_ReadById, SmsTemplate_ReadAll, SmsTemplate_ReadAllPaginated } from "src/app/GlobalVariables";
import { SmsTemplateCreateRequestDTO, SmsTemplateDeleteRequestDTO, SmsTemplateDTO, smsTemplateList, SmsTemplateReadByIdRequestDTO, SmsTemplateReadByTenantIdRequestDTO, SmsTemplateUpdateRequestDTO, smsTemplateReadAllPaginatedRequestDTO } from "./sms-template.interface";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class SmsTemplateService {

    http = inject(HttpClient)

    //Create
    SmsTemplate_Create(data: SmsTemplateCreateRequestDTO): Observable<SmsTemplateDTO> {
        return this.http.post<SmsTemplateDTO>(SmsTemplate_Create, data);
    }

    //Update
    SmsTemplate_Update(data: SmsTemplateUpdateRequestDTO): Observable<SmsTemplateDTO> {
        return this.http.post<SmsTemplateDTO>(SmsTemplate_Update, data)
    }

    //ReadById
    SmsTemplate_ReadById(data: SmsTemplateReadByIdRequestDTO): Observable<SmsTemplateDTO> {
        return this.http.post<SmsTemplateDTO>(SmsTemplate_ReadById, data);
    }

    //Delete
    SmsTemplate_Delete(data: SmsTemplateDeleteRequestDTO): Observable<SmsTemplateDTO> {
        return this.http.post<SmsTemplateDTO>(SmsTemplate_Delete, data);
    }

    //ReadByTenantId
    SmsTemplate_ReadByTenantId(data: SmsTemplateReadByTenantIdRequestDTO): Observable<smsTemplateList> {
        return this.http.post<smsTemplateList>(SmsTemplate_ReadByTenantId, data);
    }

    //ReadAll
    SmsTemplate_ReadAll(): Observable<smsTemplateList> {
        return this.http.get<smsTemplateList>(SmsTemplate_ReadAll);
    }
    ReadAllPaginatedsmsTemplate(data: smsTemplateReadAllPaginatedRequestDTO): Observable<smsTemplateList> {
        return this.http.post<smsTemplateList>(SmsTemplate_ReadAllPaginated, data);
    }

}